import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import PastPerformanceBlock from '@/components/Pages/KidsHub/KidsTable/PastPerformanceChart/PastPerformanceBlock';
import { ShareClass } from 'model/KidsHub';
import { ModalContent } from 'components/Modals/ModalContent';
import { ModalHeader } from 'components/Modals/ModalHeader';
import { ModalBody } from 'components/Modals/ModalBody';

interface PastPerformanceModalContentProps {
  shareClass: ShareClass;
  countryCode: string;
  onCloseModal: () => void;
}

const PastPerformanceModalContent: React.FC<PastPerformanceModalContentProps> = ({
  shareClass,
  countryCode,
  onCloseModal,
}) => {
  const [renderingId] = useState<string>(uuidv4());

  const shareClassId = shareClass?.shareclassID;

  return (
    <ModalContent data-e2e-component-uid={renderingId}>
      <ModalHeader title="Past Performance" onClose={onCloseModal}></ModalHeader>
      <ModalBody>
        {shareClassId && (
          <PastPerformanceBlock shareClassId={shareClassId} countryCode={countryCode} />
        )}
      </ModalBody>
    </ModalContent>
  );
};

export default PastPerformanceModalContent;
